<div #floorplan class="floorplan">
  <p l10nTranslate>template.floorplanText</p>
  <span l10nTranslate>template.description</span>
  <div class="images-block">
    <div *ngFor="let floorPlan of floorPlanImages" class="block">
      <ng-container *ngIf="floorPlan?.imageSrc; else noImage">
        <div miq-bg-image class="add-new" bgClass="custom-publish-icon-condensed" [secureImage]="floorPlan"></div>
        <div *ngIf="floorPlan?.floor_suite" class="desc">
          <ng-container> {{ floorPlan.position + '. ' }} </ng-container>
          <ng-container *ngIf="floorPlan.floor_suite.floor_number">
            {{ floorPlan.floor_suite.floor_number + 'F' }}
          </ng-container>
          <ng-container *ngIf="floorPlan.floor_suite.suite_number">
            | {{ floorPlan.floor_suite.suite_number }}
          </ng-container>
        </div>
        <div class="actions">
          <mat-icon class="edit" svgIcon="edit-icon" (click)="openDialog(floorPlan.id, 'edit')"></mat-icon>
          <mat-icon svgIcon="delete" (click)="deleteFloorPlan(floorPlan)"></mat-icon>
        </div>
      </ng-container>
      <ng-template #noImage>
        <div class="add-new" *ngIf="floorPlan?.availabilityImages > 0; else addImage">
          <div class="selectImage" (click)="openDialog(floorPlan.id, 'add')">
            <mat-icon svgIcon="add-icon"></mat-icon>
            <span l10nTranslate> template.selectImage</span>
          </div>
        </div>
        <ng-template #addImage>
          <div class="add-new" (click)="navigate(floorPlan.id)">
            <span class="text" l10nTranslate>template.noImageAvailable</span>
            <div class="upload">
              <mat-icon svgIcon="icon-upload" color="y-upload" class="mat-icon-upload"></mat-icon>
              <span l10nTranslate> template.addNew</span>
            </div>
          </div>
        </ng-template>
        <div class="block desc" *ngIf="floorPlan?.floor_suite">
          {{ floorPlan.position + '. ' }}
          <ng-container *ngIf="floorPlan.floor_suite.floor_number">
            {{ floorPlan.floor_suite.floor_number + 'F' }}
          </ng-container>
          <ng-container *ngIf="floorPlan.floor_suite.suite_number">
            | {{ floorPlan.floor_suite.suite_number }}
          </ng-container>
        </div>
      </ng-template>
    </div>
  </div>
</div>
